module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm",
    class: !_vm.drawing ? 'btn-primary' : 'btn-danger',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.draw()
      }
    }
  }, [_c('i', {
    class: !_vm.drawing ? _vm.iconClass : 'mdi mdi-window-close'
  }), _vm._v(" " + _vm._s(_vm.label))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa2e15da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/DrawButton.vue
// module id = 494
// module chunks = 1